import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { combineLatest, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ISharePointFileLintCardItem } from 'src/app/components/main-content/design-lookup/share-point-file-link-card/share-point-file-link-card.component';
import { ElementHistoryDocument } from 'src/app/models/domain';
import { DesignService, ElementHistoryDocumentService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-element-history-document-link',
  templateUrl: './element-history-document-link.component.html',
  standalone: false,
})
export class ElementHistoryDocumentLinkComponent implements OnInit, OnDestroy {
  public elementHistoryDocuments$ =
    this.elementHistoryDocumentService.elementHistoryDocuments$.pipe(
      map((elementHistoryDocument) => this.mapToSharePointLinkCardItem(elementHistoryDocument))
    );

  public error$ = this.elementHistoryDocumentService.error$;
  public siteUrl = environment.sharePointEHDSiteUrl;
  public readonly trackByRef = trackByRef;

  public isLoading = false;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly elementHistoryDocumentService: ElementHistoryDocumentService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((designId) => this.elementHistoryDocumentService.loadByDesignId(designId)))
        .subscribe()
    );

    this.subscriptions.add(
      combineLatest([this.designService.loading$, this.elementHistoryDocumentService.loading$])
        .pipe(
          map(
            ([designLoading, elementHistoryDocumentLoading]) =>
              designLoading || elementHistoryDocumentLoading
          )
        )
        .subscribe((loading) => (this.isLoading = loading))
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private mapToSharePointLinkCardItem(
    documents: ElementHistoryDocument[]
  ): ISharePointFileLintCardItem[] {
    return documents.map((document) => ({
      name: document.name,
      sharePointSiteUrl: this.siteUrl,
      webUrl: document.webUrl,
    }));
  }
}
